import { useAtom, useAtomValue } from "jotai";
import { SectionFieldSet } from "../../../../components/sectionFieldSet/SectionFieldSet";
import { LinkAnchors } from "../ContractEdit";
import { contractInvoiceState } from "../../../../state/contractInvoiceState";
import { FormName } from "../menus/ContractEditMenu";
import { useContract } from "../../../../hooks/useContract";
import { useEffect, useRef } from "react";
import { InvoiceType } from "../../../../data/models/ContractTypes";
import { RadioButtons } from "../../../../components/interactions/Radio/RadioButtons";
import { Toggle } from "../../../../components/animate/Toggle";
import { InvoiceEmail } from "./InvoiceEmail";
import { InvoiceAddress } from "./InvoiceAddress";
import { ScrollPositionAnchor } from "../../../../components/scrollPosition/ScrollPositionAnchor";
import { HiddenInput } from "../../../../components/form/HiddenInput";
import { RequiredValidator } from "../../../../components/form/validators/RequiredValidator";
import { Form } from "../../../../components/form/Form";

export const Invoices = ({ id }: { id: number }) => {
  const invoiceType = useAtomValue(contractInvoiceState);

  return (
    <SectionFieldSet
      headerTitle={LinkAnchors.INVOICING.name}
      formName={
        invoiceType.invoiceType === InvoiceType.EMAIL
          ? FormName.INVOICE_EMAIL
          : FormName.INVOICE_ADDRESS
      }
      sectionNumber={id}
    >
      <InvoicesInner />
    </SectionFieldSet>
  );
};

const InvoicesInner: React.FunctionComponent = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [invoiceType, setInvoiceType] = useAtom(contractInvoiceState);
  const contract = useContract();

  useEffect(() => {
    if (!!contract.contractData.invoiceEmail) {
      setInvoiceType({ invoiceType: InvoiceType.EMAIL });
      return;
    }

    if (contract.contractData.invoiceAddress) {
      setInvoiceType({ invoiceType: InvoiceType.ADDRESS });
      return;
    }
  }, [contract.contractData, setInvoiceType]);

  return (
    <div ref={ref}>
      <ScrollPositionAnchor id={LinkAnchors.INVOICING.anchor} />
      <RadioButtons
        className="compact"
        label="Invoice type"
        alternatives={[
          {
            value: InvoiceType.EMAIL,
            text: "Email",
          },
          {
            value: InvoiceType.ADDRESS,
            text: "Paper",
          },
        ]}
        value={invoiceType.invoiceType}
        onChange={(value) => {
          setInvoiceType({
            invoiceType: value as InvoiceType,
          });
        }}
      />

      <Form>
        <HiddenInput
          label="Select invoice type"
          value={invoiceType.invoiceType}
          scrollToRef={ref}
          validators={[new RequiredValidator("Invoice type is required")]}
        />
      </Form>

      <Toggle open={invoiceType.invoiceType === InvoiceType.EMAIL}>
        <InvoiceEmail />
      </Toggle>

      <Toggle open={invoiceType.invoiceType === InvoiceType.ADDRESS}>
        <InvoiceAddress />
      </Toggle>
    </div>
  );
};
